<div class="page-container">
  <app-custom-back-button></app-custom-back-button>
  <div class="use-cases__tiles__content">
    <span class="use-cases__tiles__title">Use Cases</span>
    <p class="use-cases__tiles__subtitle">Select an example athlete to explore</p>
    <ng-container *ngIf="tiles.length; else noData">
      <app-tile
        *ngFor="let feature of tiles"
        class="use-cases__tiles__item"
        [config]="feature">
      </app-tile>
    </ng-container>
  </div>
</div>

<ng-template #noData>
  <div class="u-text-align-center">No Use Cases Found</div>
</ng-template>
